import {HttpClient, HttpEvent, HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable, from, throwError, catchError} from 'rxjs';
import { switchMap } from 'rxjs/operators';
import {API_URL} from "../constants";

@Injectable({
    providedIn: 'root'
})
export class ConferenceFileService {
    private apiUrl = `${API_URL}` + 'business-conference';
    constructor(private http: HttpClient) { }



    uploadPresentation(
        speakerId: string,
        file: File,
        isLocal: boolean
    ): Observable<HttpEvent<any>> {

        if (isLocal) {
            // Local backend upload
            console.log("Local upload: ", file.name);
            const formData = new FormData();
            formData.append('file', file, file.name);

            return this.http.put<HttpEvent<any>>(
                `${this.apiUrl}/speaker/${speakerId}/upload`,
                formData,
                {reportProgress: true, observe: 'events'}
            ).pipe(
                catchError((err: any) => {
                    console.error('Local upload error:', err);
                    return throwError(() => err);
                })
            );

        } else {
            // S3 direct upload via presigned URL
            console.log("Prod upload: Requesting pre-signed URL");

            return this.http.post<{ uploadUrl: string }>(
                `${this.apiUrl}/speaker/${speakerId}/generate-presigned-url?filename=${encodeURIComponent(file.name)}`,
                {}
            ).pipe(
                switchMap(resp => {
                    if (!resp.uploadUrl) {
                        return throwError(() => new Error('No presigned URL returned'));
                    }

                    // FIX 1: Use the URL EXACTLY as it comes from the backend.
                    // DO NOT use encodeURI() here.
                    const s3Url = resp.uploadUrl;

                    // FIX 2: Check if your backend signed the URL with a specific Content-Type.
                    // If it did, this header must match EXACTLY.
                    // Often, it's safer to send no headers at all if the backend didn't specify.
                    const headers = new HttpHeaders({'Content-Type': file.type});

                    return this.http.put(s3Url, file, {
                        headers: headers,
                        reportProgress: true,
                        observe: 'events',
                        // FIX 3: If you have an Interceptor adding Auth headers,
                        // you might need a custom header or property to tell the interceptor to skip this request.
                        // context: new HttpContext().set(BYPASS_JWHT, true)
                    }).pipe(
                        catchError((err: any) => {
                            console.error('S3 upload error details:', err);
                            return throwError(() => err);
                        })
                    );
                })
            );
        }
    }



}
